// const BASE_URL = "http://localhost:3004/api/";
const BASE_URL = "https://v2.mindpulse.com.au/api/";

// Login/Profile
export const LOGIN_ADMIN = BASE_URL + "admin/login";
export const GET_ADMIN_PROFILE = BASE_URL + "admin/profile/get";

// Dashboard
export const GET_DASHBOARD_STATS = BASE_URL + "admin/dashboard/get";

// Page Titles
export const GET_PAGE_TITLES = BASE_URL + "admin/pageTitles/get";
export const UPDATE_PAGE_TITLE = BASE_URL + "admin/pageTitles/update";

// Users
export const GET_USERS = BASE_URL + "admin/users/get/";
export const DELETE_USER = BASE_URL + "admin/users/delete";
export const UPDATE_USER_AVAILABILITY =
  BASE_URL + "admin/users/availability/update";
export const CREATE_USER = BASE_URL + "admin/users/create";

// Recipes
export const GET_RECIPES = BASE_URL + "admin/recipes/get";
export const GET_RECIPE_DETAILS = BASE_URL + "admin/recipes/details/get/";
export const CREATE_RECIPES = BASE_URL + "admin/recipes/create";
export const UPDATE_RECIPE = BASE_URL + "admin/recipes/update";
export const DELETE_RECIPE = BASE_URL + "admin/recipes/delete";
export const UPDATE_RECIPE_AVAILABILITY =
  BASE_URL + "admin/recipes/availability/update";
export const UPDATE_RECIPE_POSITION =
  BASE_URL + "admin/recipes/position/update";

// Exercises
export const GET_EXERCISES = BASE_URL + "admin/exercises/get";
export const GET_EXERCISE_DETAILS = BASE_URL + "admin/exercises/details/get/";
export const GET_EXERCISES_CATEGORIES =
  BASE_URL + "admin/exercises/categories/get";
export const UPDATE_EXERCISE_AVAILABILITY =
  BASE_URL + "admin/exercises/availability/update";
export const CREATE_EXERCISE = BASE_URL + "admin/exercises/create";
export const DELETE_EXERCISE = BASE_URL + "admin/exercises/delete";
export const UPDATE_EXERCISE = BASE_URL + "admin/exercises/update";
export const UPLOAD_EXERCISE_VIDEO = BASE_URL + "admin/exercises/video/upload";
export const UPLOAD_EXERCISE_IMAGE = BASE_URL + "admin/exercises/image/upload";

// Virtual Commute
export const GET_VIRTUAL_COMMUTE = BASE_URL + "admin/virtual_commute/get";
export const DELETE_VIRTUAL_COMMUTE = BASE_URL + "admin/virtual_commute/delete";
export const CREATE_VIRTUAL_COMMUTE = BASE_URL + "admin/virtual_commute/create";
export const UPDATE_VIRTUAL_COMMUTE = BASE_URL + "admin/virtual_commute/update";
export const UPLOAD_VIRTUAL_COMMUTE_AUDIO =
  BASE_URL + "admin/virtual_commute/audio/upload";
export const UPLOAD_VIRTUAL_COMMUTE_IMAGE =
  BASE_URL + "admin/virtual_commute/image/upload";
export const UPDATE_VIRTUALCOMMUTE_AVAILABILITY =
  BASE_URL + "admin/virtual_commute/availability/update";
export const UPDATE_VIRTUALCOMMUTE_POSITION =
  BASE_URL + "admin/virtual_commute/position/update";

// Mindfulness
export const GET_MINDFULNESS = BASE_URL + "admin/mindfulness/get";
export const DELETE_MINDFULNESS = BASE_URL + "admin/mindfulness/delete";
export const CREATE_MINDFULNESS = BASE_URL + "admin/mindfulness/create";
export const UPDATE_MINDFULNESS = BASE_URL + "admin/mindfulness/update";
export const UPDATE_MINDFULNESS_POSITION =
  BASE_URL + "admin/mindfulness/position/update";
export const UPDATE_MINDFULNESS_AVAILABILITY =
  BASE_URL + "admin/mindfulness/availability/update";

// App Reports
export const GET_APP_REPORTS = BASE_URL + "admin/reports/get";
export const MARK_REPORT_RESOLVED = BASE_URL + "admin/reports/resolve";

// Organisations
export const GET_ORGANISATIONS = BASE_URL + "admin/organisations/get/";
export const UPDATE_ORGANISATION = BASE_URL + "admin/organisations/update";
export const DELETE_ORGANISATIONS = BASE_URL + "admin/organisations/delete";
export const RESTORE_ORGANISATION = BASE_URL + "admin/organisations/restore";
export const CHANGE_ORG_STATUS = BASE_URL + "admin/organisations/status/update";

// Notified Users
export const GET_NOTIFIED_USERS = BASE_URL + "admin/notifiedUsers/get";
export const ADD_NOTIFIED_USERS = BASE_URL + "admin/notifiedUsers/add";
export const REMOVE_NOTIFIED_USER = BASE_URL + "admin/notifiedUsers/remove";
